module.exports = {"id":"212883","name":"Daniel Amartey","rating":"74","photo":"./data/images/photos/1/212883.png","club":{"name":"Leicester City","logo":"./data/images/clubs/LeicesterCity.png"},"positions":["MDC","DD","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DanielAmartey0.json
// module id = 919
// module chunks = 0